import React, { Component } from 'react';
import AppUtils from '../../apputils';
import axios from 'axios';
import LoginPage from './login';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import $ from 'jquery';
import { LoginUser, SocialLogin } from '../../models/users';

class loginContainer extends Component {
    constructor() {
        super();
        this.state = {
            txtLoginEmail: '',
            txtLoginPassword: '',
            txtLoginValidationMessage: '',
            txtFacebookLoginEmail: '',
            loginUser: false,
            sociallogin: false
        }
        this.loginData = {}
    }

    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }

    CheckLogin = (e) => {
        if (e.keyCode === 13) {
            // alert('13')
            this.Login();
        }

    }

    HandleLoginInputs = (e) => {

        if (this.state.txtLoginValidationMessage !== '') {
            this.setState({
                txtLoginValidationMessage: ''
            })
        }
        const val = e.target.value;
        const name = e.target.name;
        this.setState({ [name]: val });
        if (name === "txtLoginEmail") this.txtLoginEmail = val;
        else if (name === "txtLoginPassword") this.txtLoginPassword = val;
    }

    Login = () => {
        const emailExpn = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (this.state.txtLoginEmail === '' || emailExpn.test(this.state.txtLoginEmail) !== true) {
            this.setState({
                txtLoginValidationMessage: 'Enter Valid Email'
            })
            return false
        }
        else {
            this.setState({
                txtLoginValidationMessage: ''
            })
        }
        if (this.state.txtLoginPassword === '') {
            this.setState({
                txtLoginValidationMessage: 'Please Enter your password'
            })
            return false
        }
        else {
            this.setState({
                txtLoginValidationMessage: ''
            })
        }
        if (this.state.txtLoginValidationMessage === '') {
            this.loginData = {
                txtLoginEmail: this.state.txtLoginEmail,
                txtLoginPassword: this.state.txtLoginPassword
            }

            this.setState({ loginUser: true })
        }
    }

    responseSuccessGoogle = (response) => {

        console.log(response);

        this.loginData = {
            email: response.profileObj.email,
            name: response.profileObj.name,
            googleId: response.profileObj.googleId,
        }
        // localStorage.setItem('current_user_email', response.profileObj.email);
        // localStorage.setItem('current_user_id', response.googleId);
        // localStorage.setItem('current_user_profile', response.profileObj);
        // localStorage.setItem('current_user_full_name', response.profileObj.name);
        // localStorage.setItem('current_user_login_token', response.tokenObj.access_token);
        // localStorage.setItem('login_token_expire_time', response.tokenObj.expires_at);
        // localStorage.setItem('current_user_name', response.profileObj.name);
        // this.HandleRouting('home');

        this.setState({ sociallogin: true })

        // console.log(this.loginData);
        // console.log(response)
    }


    responseFailureGoogle = (resp) => {
        console.log(resp);
    }

    responseSuccessFacebook = (response) => {
        // axios({
        // console.log('fb' + response)
        //     method: 'GET',
        //     url: `https://graph.facebook.com/v2.11/${response.userID}/?fields=id,name,email&access_token=${response.accessToken}`
        // }).then(res => {
        //     // this.setState({
        //     //     txtFacebookLoginEmail: res.data.email
        //     // })

        //     console.log(res);
        //     console.log(response)

        // })
        //    console.log(response)
        this.loginData = {
            email: response.email,
            name: response.name,
            googleId: response.id,
        }
        this.setState({
            sociallogin: true
        })
        console.log(',,,' + JSON.stringify(this.loginData))

    }

    PushNotification = (externalUserId) => {
        var data = JSON.stringify({
          "app_id": "b73b1d9d-2e6e-43fe-81e1-b9ab31caba87",
          //   "included_segments": [
          //     "Subscribed Users"
          //   ],
          "channel_for_external_user_ids": "push",
          "include_external_user_ids": [externalUserId],
          "data": {
            "foo": "bar"
          },
          "name": "Event",
          "contents": {
            "en": `Kinship welcomes you, Please login to explore the sessions`
          },
    
          "url": "https://www.kinshipliving.com/upcoming-sessions",
    
    
        });
    
        var config = {
          method: 'post',
          url: 'https://onesignal.com/api/v1/notifications',
          headers: {
            'Authorization': 'Basic YWJmOTYyNDktODE0NC00Y2FjLWE2NTItODQxZmVhNThhNGNl',
            'Content-Type': 'application/json'
          },
          data: data
        };
    
        axios(config)
          .then(function (response) {
            console.log(JSON.stringify(response.data));
          })
          .catch(function (error) {
            console.log(error);
          });
    
      }
    

    HandleLoginDataSuccessResponse1 = (res) => {
        if (res !== false) {
            alert(JSON.stringify(res))
            document.getElementById('spnSuccessMessageTitle').innerText = "Login Response - ";
            // document.getElementById('spnSuccessMessage').innerText = res.data.userloginresponse.message.value;
            document.getElementById('spnSuccessMessage').innerText = 'Successfully Logged In';
            let that = this;
            $('#crmSuccessAlert').slideDown().slideUp(3000, function () {
                AppUtils.HandlePageClick(that.props.componentprops, 'home');
            })
        }
        else {
            // alert(JSON.stringify(this.props.PnkStore.GetData('error')));

            document.getElementById('spnWarningMessageTitle').innerText = "Login Response - ";
            document.getElementById('spnWarningMessage').innerText = this.props.PnkStore.GetData('error').prettyMessage;
          //  let that = this;
            $('#crmWarningAlert').slideDown().slideUp(3000, function () {
                // AppUtils.HandlePageClick(that.props.componentprops, 'leads');
            })
        }
        this.setState({ loginUser: false });
    }

    HandleLoginDataSuccessResponse = (res) => {
        if (res !== false) {
            console.log(JSON.stringify(res))
            let d = new Date();
            d.setMinutes(d.getMinutes() + 240);
            if (res.data.userloginresponse.rows.length > 0) {
                if (res.data.userloginresponse.rows[0].user_email === 'finelogics.prabhash@gmail.com')
                    d.setMinutes(d.getMinutes() + 24000);
                localStorage.setItem('current_user_id', res.data.userloginresponse.rows[0]._id);
                localStorage.setItem('current_user_email', res.data.userloginresponse.rows[0].user_email);
                localStorage.setItem('current_user_profile', res.data.userloginresponse.rows[0].user_profile);
                localStorage.setItem('current_user_full_name', res.data.userloginresponse.rows[0].user_full_name);
                localStorage.setItem('current_user_login_token', res.data.userloginresponse.token);
                localStorage.setItem('login_token_expire_time', d);
                localStorage.setItem('current_user_pic', res.data.userloginresponse.rows[0].profile_pic);
                localStorage.setItem('referral_count', res.data.userloginresponse.rows[0].referral_count)
                sessionStorage.setItem('current_user_referral_code', res.data.userloginresponse.rows[0].referral_code)
            }

            window.OneSignal = window.OneSignal || [];
         //   var OneSignal = OneSignal || [];

            let externalUserId = res.data.userloginresponse.rows[0]._id
          
            window.OneSignal.push(function () {
            //    alert(externalUserId)
               window.OneSignal.setExternalUserId(externalUserId);
            });

        //    this.PushNotification(externalUserId);

            document.getElementById('spnSuccessMessageTitle').innerText = "Login Response - ";
            document.getElementById('spnSuccessMessage').innerText = "Successfully Logged In";
           // let that = this;

            this.props.PnkStore.SetData('loginstatus', true)
            if (res.data.userloginresponse.rows[0].user_full_name === undefined || res.data.userloginresponse.rows[0].user_full_name === null || res.data.userloginresponse.rows[0].user_full_name === '') {
                let name = (res.data.userloginresponse.rows[0].user_email).substring(0, (res.data.userloginresponse.rows[0].user_email).indexOf("@"));
                this.props.PnkStore.SetData('loginusername', name)
                localStorage.setItem('current_user_name', name);
            }
            else {
                this.props.PnkStore.SetData('loginusername', res.data.userloginresponse.rows[0].user_full_name)
                localStorage.setItem('current_user_name', res.data.userloginresponse.rows[0].user_full_name);
            }

            this.props.PnkStore.BroadCast();

            // $('#crmSuccessAlert').slideDown().slideUp(3000, function () {
            //     AppUtils.HandlePageClick(that.props.componentprops, 'home');
            // })
        }
        else {
            //  document.getElementById('spnWarningMessageTitle').innerText = "Login Response - ";
            //  document.getElementById('spnWarningMessage').innerText = this.props.PnkStore.GetData('error').prettyMessage;
           // let that = this;
            this.setState({
                txtLoginValidationMessage: this.props.PnkStore.GetData('error').prettyMessage
            })
            // $('#crmWarningAlert').slideDown().slideUp(3000, function () {
            //     // AppUtils.HandlePageClick(that.props.componentprops, 'leads');
            // })
        }
        this.setState({ loginUser: false });
    }

    HandleSocialLoginDataSuccessResponse = (res) => {
        if (res !== false) {
            let d = new Date();
            d.setMinutes(d.getMinutes() + 240);

            if (res.data.userloginresponse.rows.length > 0) {
                if (res.data.userloginresponse.rows[0].user_email === 'finelogics.prabhash@gmail.com')
                    d.setMinutes(d.getMinutes() + 24000);
                localStorage.setItem('current_user_id', res.data.userloginresponse.rows[0]._id);
                localStorage.setItem('current_user_email', res.data.userloginresponse.rows[0].user_email);
                localStorage.setItem('current_user_profile', res.data.userloginresponse.rows[0].user_profile);
                localStorage.setItem('current_user_full_name', res.data.userloginresponse.rows[0].user_full_name);
                localStorage.setItem('current_user_login_token', res.data.userloginresponse.token);
                localStorage.setItem('login_token_expire_time', d);
                localStorage.setItem('current_user_pic', res.data.userloginresponse.rows[0].profile_pic);
                localStorage.setItem('referral_count', res.data.userloginresponse.rows[0].referral_count === undefined ? 0 : res.data.userloginresponse.rows[0].referral_count)
                sessionStorage.setItem('current_user_referral_code', res.data.userloginresponse.rows[0].referral_code);

            }

           

            document.getElementById('spnSuccessMessageTitle').innerText = "Login Response - ";
            document.getElementById('spnSuccessMessage').innerText = "Successfully Logged In";
        //    let that = this;

            let externalUserId = res.data.userloginresponse.rows[0]._id
           
           // var OneSignal = OneSignal || [];
           window.OneSignal = window.OneSignal || [];
            window.OneSignal.push(function () {
            //    alert(externalUserId)
                window.OneSignal.setExternalUserId(externalUserId);
            });

           // this.PushNotification(externalUserId);


            this.props.PnkStore.SetData('loginstatus', true)
            if (res.data.userloginresponse.rows[0].user_full_name === undefined || res.data.userloginresponse.rows[0].user_full_name === null || res.data.userloginresponse.rows[0].user_full_name === '') {
                let name = (res.data.userloginresponse.rows[0].user_email).substring(0, (res.data.userloginresponse.rows[0].user_email).indexOf("@"));
                this.props.PnkStore.SetData('loginusername', name)
                localStorage.setItem('current_user_name', name);
            }
            else {
                this.props.PnkStore.SetData('loginusername', res.data.userloginresponse.rows[0].user_full_name)
                localStorage.setItem('current_user_name', res.data.userloginresponse.rows[0].user_full_name);
            }

            this.props.PnkStore.BroadCast();

            // $('#crmSuccessAlert').slideDown().slideUp(3000, function () {
            //     AppUtils.HandlePageClick(that.props.componentprops, 'home');
            // })
        }
        else {
            // document.getElementById('spnWarningMessageTitle').innerText = "Login Response - ";
            // document.getElementById('spnWarningMessage').innerText = this.props.PnkStore.GetData('error').prettyMessage;
            // let that = this;
            // $('#crmWarningAlert').slideDown().slideUp(3000, function () {
            //     // AppUtils.HandlePageClick(that.props.componentprops, 'leads');
            // })
            this.setState({
                txtLoginValidationMessage: this.props.PnkStore.GetData('error').prettyMessage
            })
        }
        this.setState({ sociallogin: false });
    }


    render() {

        return (
            <div>
                {localStorage.getItem('current_user_name') == null && localStorage.getItem('current_user_login_token') == null && localStorage.getItem('current_user_profile') == null ?
                    <LoginPage {...this.props} txtLoginEmail={this.state.txtLoginEmail}
                        txtLoginPassword={this.state.txtLoginPassword}
                        txtLoginValidationMessage={this.state.txtLoginValidationMessage}
                        txtFacebookLoginEmail={this.state.txtFacebookLoginEmail}
                        Login={this.Login} HandleLoginInputs={this.HandleLoginInputs}
                        responseSuccessGoogle={this.responseSuccessGoogle}
                        responseFailureGoogle={this.responseFailureGoogle}
                        responseSuccessFacebook={this.responseSuccessFacebook}
                        HandleRouting={this.HandleRouting}
                        CheckLogin={this.CheckLogin}
                    />

                    : AppUtils.HandlePageClick(this.props.componentprops, 'home')}
                {((this.state.loginUser === true) ? LoginUser(this.props.PnkStore, this.loginData, this.HandleLoginDataSuccessResponse) : "")}
                {((this.state.sociallogin === true) ? SocialLogin(this.props.PnkStore, this.loginData, this.HandleSocialLoginDataSuccessResponse) : "")}
            </div>
        )
    }

}
export const LoginContainer = PnkConnect(loginContainer, '');